/**
 * YUL On Tap — High-Tech Interaction Design System
 * 
 * Semantic accent colors for action categories.
 * Each color communicates the FUNCTION of the action.
 */

export const SEMANTIC_ACCENTS = {
  safety:     { color: '#ef4444', glow: 'rgba(239,68,68,0.3)',  border: 'rgba(239,68,68,0.4)',  bg: 'rgba(239,68,68,0.08)'  },
  damaged:    { color: '#a855f7', glow: 'rgba(168,85,247,0.3)', border: 'rgba(168,85,247,0.4)', bg: 'rgba(168,85,247,0.08)' },
  assistance: { color: '#3b82f6', glow: 'rgba(59,130,246,0.3)', border: 'rgba(59,130,246,0.4)', bg: 'rgba(59,130,246,0.08)' },
  search:     { color: '#06b6d4', glow: 'rgba(6,182,212,0.3)',  border: 'rgba(6,182,212,0.4)',  bg: 'rgba(6,182,212,0.08)'  },
  security:   { color: '#f97316', glow: 'rgba(249,115,22,0.3)', border: 'rgba(249,115,22,0.4)', bg: 'rgba(249,115,22,0.08)' },
  general:    { color: '#64748b', glow: 'rgba(100,116,139,0.3)',border: 'rgba(100,116,139,0.4)',bg: 'rgba(100,116,139,0.08)'},
  success:    { color: '#22c55e', glow: 'rgba(34,197,94,0.3)',  border: 'rgba(34,197,94,0.4)',  bg: 'rgba(34,197,94,0.08)'  },
};

/**
 * Map category IDs to semantic accent keys.
 * Extend this map for new categories.
 */
export const CATEGORY_ACCENT_MAP = {
  spill_hazard:        'safety',
  damaged_item:        'damaged',
  need_assistance:     'assistance',
  product_missing:     'search',
  suspicious_activity: 'security',
  custom:              'general',
};

export function getAccent(categoryId) {
  const key = CATEGORY_ACCENT_MAP[categoryId] || 'general';
  return SEMANTIC_ACCENTS[key] || SEMANTIC_ACCENTS.general;
}
